import { Primitive, WidenLiterals } from '@treasury/utils';
import { isEdited } from './is-edited';

export const getDisplayValue = <T extends Primitive>(
    original?: WidenLiterals<T>,
    edited?: WidenLiterals<T>
) => (isEdited(original, edited) ? edited : original);
